import React from 'react';
import './CTA.css';
import { FiArrowUpRight, FiDatabase, FiShield, FiZap } from 'react-icons/fi';

const CTA = () => {
  return (
    <section className="product-focus section-padding" id="dataface">
      <div className="site-container product-focus-grid">
        <div className="product-focus-copy">
          <span className="eyebrow">Current product focus</span>
          <h2>Data + AI initiative, led by Dataface.ai.</h2>
          <p>
            Dataface.ai is the active product in SmartSastram's Data + AI initiative, built for teams that need cleaner data workflows, stronger AI evaluation, and practical operating controls.
          </p>
          <div className="product-actions">
            <a href="https://dataface.ai" target="_blank" rel="noreferrer" className="btn-primary-site">
              Visit Dataface.ai <FiArrowUpRight />
            </a>
            <a href="#quote" className="btn-secondary-site">Explore the initiative</a>
          </div>
        </div>

        <div className="product-panel">
          <div className="product-panel-header">
            <span>Data + AI</span>
            <strong>Product operating priorities</strong>
          </div>
          <div className="product-panel-items">
            <div>
              <FiDatabase />
              <h3>Data workflow layer</h3>
              <p>Structure data discovery, enrichment, and readiness for downstream AI systems.</p>
            </div>
            <div>
              <FiZap />
              <h3>AI execution layer</h3>
              <p>Support practical product flows that connect users, prompts, models, and outputs.</p>
            </div>
            <div>
              <FiShield />
              <h3>Governance layer</h3>
              <p>Add evaluation, controls, and observability so enterprise adoption can scale responsibly.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
